export default __webpack_public_path__ + "static/media/Logo-EOA-Scanner.2a49906d.png";